@let _openedUidLevel1 = openedUidLevel1();
@let _openedUidLevel2 = openedUidLevel2();
@let _openedMobile = openedMobile();
@let _isDesktop = isDesktop();

<button
  [attr.tabindex]="(!isDesktop && _openedMobile) ? '0' : '-1'"
  class="c__focusguard is-visually-hidden"
  (focus)="onFocusGuardModal('first')"
></button>

@if (!_isDesktop) {
  @let _title = (_openedMobile ? 'navigation.a11y.close' : 'navigation.a11y.open') | translate;
  <button
    #mobileMenuButton
    sd-button-icon
    class="c__mobile-menu-btn"
    [icon]="_openedMobile ? 'icon-cross' : 'icon-burger'"
    [attr.aria-expanded]="_openedMobile"
    [attr.aria-label]="_title"
    [buttonIconTitle]="_title"
    [titleHidden]="true"
    (click)="toggleMobileMenu()"
  ></button>
}

<nav
  role="navigation"
  class="is-menu-type"
  [@expandCollapse]="_isDesktop ? '1-no-hidden' : _openedMobile ? '1-auto' : '0'"
  [attr.aria-expanded]="_openedMobile"
  [attr.aria-label]="'navigation.a11y.menu' | translate"
>
  <div class="c__wrapper is-level-1">
    <!--Level 1-->
    <ul #mainNavigationList
      role="menubar"
      class="c__nav-main-list is-level-1 is-{{(_isDesktop) ? textConfig : 'left'}}"
      sd-list-inline
    >
      @for (category of menuItems(); track category.uid) {
        @let _isLevel1Open = _openedUidLevel1 === category.uid;
        <li
          role="menuitem"
          #mainNavigationItem
          [id]="category.uid"
          class="c__nav-item {{
            _openedUidLevel1 && !_isLevel1Open && !_isDesktop ? 'is-visually-hidden' : ''
          }} {{category.highlight ? 'is-highlighted' : ''}}"
        >
          <ng-container *ngTemplateOutlet="menuLinkTemplate; context:{
              category: category,
              activeId: activeId(),
              openedUidLevel: _openedUidLevel1,
              level: 1,
              index: $index,
              navigation: category.title
            }"
          />
          <!--Level 2-->
          <div
            class="c__wrapper is-level-2"
            [@slideInOutHorizontally]="_isDesktop ? '1' : (_isLevel1Open ? '1' : '0')"
            [@expandCollapse]="!_isDesktop ? '1-no-hidden' : (_isLevel1Open ? '1-no-hidden' : '0')"
            [attr.aria-expanded]="_isLevel1Open"
            (mouseleave)="_isDesktop && closeMenu()"
          >
            <div
              class="c__wrapper-content
              {{category.numberOfBrandCat > 0 || (category.others?.pushs?.length > 0 && category.brandCornerPush?.brand) ? 'has-brand-cat' : ''}}
              {{category.numberOfBrandCat > 1 ? 'has-multiple-columns' : ''}}
              {{category.others?.pushs?.length > 0 ? 'has-push': ''}}"
            >
              <ul
                role="menu"
                class="c__nav-list is-level-2 is-{{textConfig}} {{_isDesktop ? 'is-xl' : 'is-l'}} {{category.hasLevel3 ? '' : 'is-column'}}"
                sd-list-inline
              >
                @for (subcategory of category.children; track subcategory.uid) {
                  @let _isLevel2Open = _openedUidLevel2 === subcategory.uid;

                  <li role="menuitem" [id]="subcategory.uid">
                    <!-- Link or button open level 3-->
                    <ng-container
                      *ngTemplateOutlet="menuLinkTemplate; context: {
                        category: subcategory,
                        activeId: subcategoryActiveId(),
                        openedUidLevel: openedUidLevel2,
                        level: 2,
                        navigation: category.title + '/' + subcategory.title
                      }"
                    />

                    <!--Level 3-->
                    @if (subcategory.children?.length > 0) {
                      <ul
                        role="menu"
                        class="c__nav-sub-list is-level-3 is-{{textConfig}} is-text-left {{subcategory.children?.length > 4 ? 'is-large' : 'is-small'}}"
                        [@expandCollapse]="(!_isDesktop && _isLevel2Open) ? '1' : _isDesktop ? '1' : '0'"
                        [attr.aria-expanded]="_isLevel2Open"
                        sd-list-block
                      >
                        @if (!_isDesktop && subcategory.linksList?.length > 0) {
                          <li role="menuitem">
                            <sd-link
                              [link]="subcategory.linksList[0]"
                              (clicked)="onLinkClick(
                                $event,
                                3,
                                category.title + '/' + subcategory.title,
                                subcategory,
                                'navigation.menu.seeAll'
                              )"
                              customClass="c__nav-link is-reset is-full-area is-level-3"
                            >
                              {{'navigation.menu.seeAll' | translate}} - {{subcategory.title}}
                            </sd-link>
                          </li>
                        }
                        @for (sub of subcategory.children; track sub.uid) {
                          <li role="menuitem" [id]="sub.uid">
                            <sd-link
                              [link]="sub.linksList[0]"
                              [ngClass]="{'is-brand-corner-link': sub.brand}"
                              (clicked)="onLinkClick(
                                $event,
                                3,
                                category.title + '/' + subcategory.title + '/' + sub.title,
                                sub,
                                undefined,
                                !!sub.brand,
                                sub.brand
                              )"
                              customClass="{{_isDesktop ? 'is-reset' : 'c__nav-link is-reset is-full-area is-level-3'}} {{sub.isMain ? 'is-bold' : ''}}"
                            >
                              <span>{{sub.title}}</span>
                              @if (sub.brand && sub.brandCornerMedia && (subcategory.brand !== sub.brand)) {
                                <ng-container *ngTemplateOutlet="byBrand; context: {media: sub.brandCornerMedia}" />
                              }
                            </sd-link>
                          </li>
                        }
                      </ul>
                    }
                  </li>
                }
              </ul>

              <!-- BRAND CORNER Categories pushcards -->
              @if (category.brandCornerPush) {
                <div class="c__brand-corner">
                  <ul sd-list-inline
                    role="menu"
                    class="c__nav-list is-brand-corner-list is-level-2 is-{{textConfig}} {{_isDesktop ? 'is-xl' : 'is-l'}} {{category.hasLevel3 ? '' : 'is-column'}}"
                  >
                    <!-- pushcards -->
                    @if (category.others?.pushs?.length > 0) {
                      <li class="is-brand-corner-push-card">
                        @let _brandPush = category.brandCornerPush;
                        @if (_brandPush.brand) {
                          <ng-container class="c__pushs">
                            <sd-push-card
                              (clicked)="onPushCardClicked(_brandPush.push)"
                              (clickCardFrames)="onClickCardFrames(_brandPush.push)"
                              [brand]="_brandPush.brand"
                              [indexFollow]="_brandPush.indexFollow !== undefined ? _brandPush.indexFollow : true"
                              [textConfig]="_brandPush.textConfig"
                              [pushSize]="PushSizeEnum.s"
                              [mediaConfig]="_brandPush.mediaConfig"
                              [mediaAsBackground]="_brandPush.mediaAsBackground"
                              [push]="_brandPush.push"
                              [titleLevel]="_brandPush.titleLevel"
                              [imageRatio]="_brandPush.imageRatio"
                              [themesConfig]="_brandPush.themesConfig"
                            />
                          </ng-container>
                        }
                      </li>
                    }
                  </ul>
                </div>
              }

              <!-- Extra links -->
              @if (category.others) {
                <ul sd-list-block class="c__extra-links {{_isDesktop ? '' : 'c__nav-list'}}">
                  @if (_isDesktop && category.others?.title) {
                    <p class="c__links-label">
                      {{category.others?.title}}
                    </p>
                  }
                  @if (category.others?.links?.length > 0) {
                    @for (link of category.others.links; track link.linkName) {
                      <li role="menuitem">
                        @if (link.url) {
                          <sd-link
                            [link]="link"
                            [theme]="link.theme"
                            (clicked)="onLinkClick($event, 3)"
                            customClass="is-reset is-bold {{_isDesktop ? '' : 'c__nav-link'}}"
                          >
                            {{link.linkName}}
                          </sd-link>
                        }
                      </li>
                    }
                  }
                  @if (category.others?.pushs?.length > 0 && !category.brandCornerPush) {
                    @for (otherPush of category.others.pushs; track otherPush) {
                      @if (!otherPush?.brand) {
                        <li class="c__pushs">
                          <sd-push-card
                            (clicked)="onPushCardClicked(otherPush.push)"
                            (clickCardFrames)="onClickCardFrames(otherPush.push)"
                            [indexFollow]="otherPush.indexFollow !== undefined ? otherPush.indexFollow : true"
                            [textConfig]="otherPush.textConfig"
                            [pushSize]="PushSizeEnum.s"
                            [mediaConfig]="otherPush.mediaConfig"
                            [mediaAsBackground]="otherPush.mediaAsBackground"
                            [push]="otherPush.push"
                            [titleLevel]="otherPush.titleLevel"
                            [imageRatio]="otherPush.imageRatio"
                            [themesConfig]="otherPush.themesConfig"
                          />
                        </li>
                      }
                    }
                  }
                  <ng-container *ngTemplateOutlet="pushTemplate()" />
                </ul>
              }
            </div>
          </div>
        </li>
      }
    </ul>

    @if (!_isDesktop && !_openedUidLevel1) {
      @if (iconLinks(); as _iconLinks) {
        <ul class="c__icon-links">
          @for (il of _iconLinks; track il.iconName) {
            <li>
              <sd-link
                customClass="is-full-area c__nav-link"
                [buttonIconTitle]="il.link.linkName"
                [icon]="il.iconName"
                [size]="IconSize.small"
                role="button"
                [titleHidden]="false"
                [link]="il.link"
                (clicked)="onLinkClick($event, 3)"
              />
            </li>
          }
        </ul>
      }
    }

    @let _languageSelectorData = languageSelectorData();

    <sd-language-selector #languageSelector
      class="{{!_isDesktop && !_openedUidLevel1 ? '' : 'is-visually-hidden'}}"
      [isFocusable]="!_isDesktop && !_openedUidLevel1"
      [languages]="_languageSelectorData?.languages"
      [activeIsoCode]="_languageSelectorData?.activeIsoCode"
      (languageSelected)="changeLanguage($event)"
    />

    <span class="c__border-bottom"></span>
    <span #activeBar class="c__active-bar"></span>

    <button
      [attr.tabindex]="(!_isDesktop && _openedMobile) ? '0' : '-1'"
      class="c__focusguard is-visually-hidden"
      (focus)="onFocusGuardModal('last')"
    ></button>
  </div>
</nav>

<ng-template #menuLinkTemplate
  let-category="category"
  let-activeId="activeId"
  let-index="index"
  let-openedUidLevel="openedUidLevel"
  let-level="level"
  let-navigation="navigation"
>
  @if (category.uid === activeId || (!category.links || category.links?.length === 0)) {
    @if (category.children?.length > 0) {
      @if (level === 1 || !_isDesktop) {
        @let _levelOpen = openedUidLevel === category.uid;
        <button
          [attr.aria-expanded]="_levelOpen"
          type="button"
          class="c__nav-link is-reset is-level-{{level}}
            {{category.uid === activeId ? 'is-active' : ''}}
            {{_levelOpen ? 'is-collapse' : '' }}
            {{!_isDesktop ? 'is-body-m' : ''}}"
          (mouseover)="_isDesktop && openMenuLevel($event, category.uid, level, navigation, index)"
          (click)="openMenuLevel($event, category.uid, level, navigation, index)"
        >
          <!-- Level 1 display -->
          @if (level === 1) {
            @if (category.uid === activeId) {
              <span class="is-visually-hidden">
                {{'navigation.a11y.currentPage' | translate}}
              </span>
            }
            @if (!_isDesktop && category.children?.length > 0 && _levelOpen) {
              <sd-icon [size]="IconSize.small" name="icon-arrow-left" />
            }
            @if (category.isMain && _isDesktop) {
              <sd-icon [size]="IconSize.small" name="icon-burger" />
            }
            {{category.title}}
            @if (!_isDesktop && category.children?.length > 0 && openedUidLevel !== category.uid) {
              <sd-icon [size]="IconSize.small" name="icon-arrow-right" />
            }
          }
          <!-- Level 2 - mobile (as a button) -->
          @if (level === 2 && !_isDesktop) {
            @if (category.media && (!category.media?.url && !category.media?.urlTwicPic) && !category.brand) {
              <sd-icon [name]="category.media" [size]="IconSize.small" />
            }
            @if (category.media && (category.media?.url || category.media?.urlTwicPic) && !category.brand) {
              <sd-banner
                [media]="category.media"
                [imgRatio]="ImgRatio.r1_1"
                [twicPicsAutoSize]="false"
                [isFit]="true"
              />
            }
            @if (category.brand && category.media) {
              <sd-banner
                class="c__brand-logo"
                [twicPicsAutoSize]="false"
                [isFit]="true"
                [media]="category.media"
              />
            }
            @if ((category.brand && category.media) || !category.brand) {
              <span>{{category.title}}</span>
            }
            @if (category.brand && !category.media) {
              <p>
                {{category.title}}
                <sd-html
                  innerClass="is-overline c__by-brand"
                  [html]="'navigation.menu.byBrand' | translate: {'brand': category.brand}"
                  tag="span"
                />
              </p>
            }
            <sd-icon
              [size]="IconSize.small"
              [name]="_levelOpen ? 'icon-minus' : 'icon-plus'"
            />
          }
        </button>
      }
      <!-- level 2 - desktop -->
      @if (level === 2 && _isDesktop) {
        @if (category.linksList?.length > 0) {
          <sd-link
            [link]="category.linksList[0]"
            [theme]="category.theme"
            (clicked)="onLinkClick($event, level, navigation, category.title, null, !!category.brand)"
            class="c__nav-link is-level-{{level}}"
            customClass="is-reset c__nav-link"
          >
            @if (category.media && (!category.media.url && !category.media.urlTwicPic) && !category.brand) {
              <sd-icon [name]="category.media" [size]="IconSize.medium" />
            }
            @if (category.media && (category.media.url || category.media.urlTwicPic)) {
              <sd-banner
                [media]="category.media"
                [imgRatio]="ImgRatio.r1_1"
                [twicPicsAutoSize]="false"
                [isFit]="true"
              />
            }
            <span class="c__by-brand-container">
              {{category.title}}
              @if (category.brand) {
                <sd-html
                  innerClass="is-overline c__by-brand"
                  [html]="'navigation.menu.byBrand' | translate: {'brand': category.brand}"
                  tag="span"
                />
              }
            </span>
          </sd-link>
        }
        @if (!category.linksList?.length) {
          <span class="c__nav-link">
            @if (category.media && (!category.media?.url && !category.media?.urlTwicPic) && !category.brand) {
              <sd-icon [name]="category.media" [size]="IconSize.medium" />
            }
            @if (category.media && (category.media?.url || category.media?.urlTwicPic)) {
              <sd-banner
                [media]="category.media"
                [imgRatio]="ImgRatio.r1_1"
                [twicPicsAutoSize]="false"
                [isFit]="true"
              />
            }
            <span class="c__by-brand-container">
              {{category.title}}
              @if (category.brand) {
                <sd-html
                  innerClass="is-overline c__by-brand"
                  [html]="'navigation.menu.byBrand' | translate: {'brand': category.brand}"
                  tag="span"
                />
              }
            </span>
          </span>
        }
      }
    }
    @if (!category.children?.length && category.linksList?.length > 0) {
      <sd-link
        [link]="category.linksList[0]"
        [theme]="category.theme"
        (clicked)="onLinkClick($event, level, navigation, category.title, null, !!category.brand)"
        (mouseover)="level === 1 && !_openedMobile && closeMenu()"
        class="c__nav-link is-level-{{level}}"
        customClass="is-reset c__nav-link"
      >
        {{category.title}}
      </sd-link>
    }
  }
</ng-template>

<ng-template #brandCornerColTemplate let-category="category" let-subcategory="subcategory">
  @if (subcategory?.brand) {
    <li
      role="menuitem"
      [class]="subcategory.children?.length > 1 ? 'is-xl' : ''"
      [id]="subcategory.uid"
    >
      <!-- Link or button open level 3-->
      <ng-container
        *ngTemplateOutlet="menuLinkTemplate; context:{
          category: subcategory,
          activeId: subcategoryActiveId(),
          openedUidLevel: openedUidLevel2,
          level: 2,
          navigation: category.title + '/' + subcategory.title
        }"
      />
      <!--Level 3-->
      @if (subcategory.children?.length > 0) {
        @let _openLevel2 = _openedUidLevel2 === subcategory.uid;
        <ul
          role="menu"
          class="c__nav-sub-list is-level-3 is-{{textConfig}} is-text-left {{subcategory.children?.length > 4 ? 'is-large' : 'is-small'}}"
          [@expandCollapse]="(!_isDesktop && _openLevel2) ? '1' : _isDesktop ? '1' : '0'"
          [attr.aria-expanded]="_openLevel2"
          sd-list-block
        >
          @if (!_isDesktop && subcategory.linksList?.length > 0) {
            <li role="menuitem">
              <sd-link
                [link]="subcategory.linksList[0]"
                (clicked)="onLinkClick(
                  $event,
                  3,
                  category.title + '/' + subcategory.title,
                  subcategory,
                  'navigation.menu.seeAll',
                  true
                )"
                customClass="c__nav-link is-reset is-full-area is-level-3"
              >
                {{'navigation.menu.seeAll' | translate}} - {{subcategory.title}}
              </sd-link>
            </li>
          }
          @for (subCateg of subcategory.children; track subCateg.uid) {
            <li role="menuitem" [id]="subCateg.uid">
              <sd-link
                [link]="subCateg?.linksList[0]"
                (clicked)="onLinkClick(
                  $event,
                  3,
                  category.title + '/' + subcategory.title + '/' + subCateg.title,
                  subCateg,
                  null,
                  true
                )"
                customClass="{{_isDesktop ? 'is-reset' : 'c__nav-link is-reset is-full-area is-level-3'}} {{subCateg.isMain ? 'is-bold' : ''}}"
              >
                {{subCateg.title}}
              </sd-link>
            </li>
          }
        </ul>
      }
    </li>
  }
</ng-template>

<ng-template #byBrand let-media="media">
  <div class="c__by-brand-subcat">
    <sd-html innerClass="is-overline" [html]="'navigation.menu.byBrand' | translate: {'brand': ''}" />
    @if (media) {
      <sd-banner
        class="c__brand-logo-subcat"
        [twicPicsAutoSize]="false"
        [isFit]="true"
        [media]="media"
      />
    }
  </div>
</ng-template>
